import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import State from 'src/application/core/State';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import EstimationsImportRequested from '../events/EstimationsImportRequested';
import EstimationsImportSucceed from '../events/EstimationsImportSucceed';
import EstimationsImportFailed from '../events/EstimationsImportFailed';
import RequestFailed from '../../core/events/RequestFailed';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(EstimationsImportRequested.type),
        mergeMap((event: EstimationsImportRequested) => {
            return backend.post(`${api()}estimations/import`, JSON.stringify(event.rows)).pipe(
                map(
                    (ajaxResponse: AjaxResponse) =>
                        new EstimationsImportSucceed(ajaxResponse.response.rowsToImport, ajaxResponse.response.messages)
                ),
                catchError((e: AjaxError) => of(new EstimationsImportFailed(e.response), new RequestFailed(e.status)))
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/estimations/epic/estimationsImport.ts